import { z } from "zod";

export default {
  params: z.object({
    scaWalletId: z.string(),
  }),
  response: z.object({
    rpId: z.string(),
    publicKeyCredentialIds: z.array(z.string()),
  }),
};
